var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.isMobile
      ? _vm.$options.components.MobileTopAppBar
      : _vm.$options.components.Heading,_vm._b({tag:"component",scopedSlots:_vm._u([{key:"actions",fn:function(){return [_vm._t("actions")]},proxy:true},{key:"actions-append",fn:function(){return [_vm._t("actions-append")]},proxy:true},{key:"title",fn:function(){return [_vm._t("title")]},proxy:true},{key:"subtitle",fn:function(){return [_vm._t("subtitle")]},proxy:true}],null,true)},'component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }